import React, { useMemo } from "react";

const Snowfall = ({ count = 28, className = "" }) => {
  const flakes = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => {
        const size = 2 + ((i * 7) % 5);
        return {
          key: i,
          left: `${(i * 97) % 100}%`,
          size,
          duration: `${16 + ((i * 13) % 18)}s`,
          delay: `-${(i * 3.1) % 22}s`,
          drift: `${((i % 5) - 2) * 28}px`,
          opacity: 0.25 + ((i % 4) * 0.16),
        };
      }),
    [count],
  );

  return (
    <div
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      aria-hidden="true"
    >
      {flakes.map((f) => (
        <span
          key={f.key}
          className="flake"
          style={{
            left: f.left,
            width: f.size,
            height: f.size,
            opacity: f.opacity,
            animationDuration: f.duration,
            animationDelay: f.delay,
            "--drift": f.drift,
          }}
        />
      ))}
    </div>
  );
};

export default Snowfall;
